import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
  compose,
  setDisplayName,
  setPropTypes,
  branch,
  renderComponent,
  renderNothing,
  lifecycle,
} from 'recompose';
import { withBreakpoint } from '../../enhancers';
import Tabs from '../common/Tabs';
import TabList from '../common/Tabs/TabList';
import TabContent from '../common/Tabs/TabContent';
import TabPanel from '../common/Tabs/TabPanel';
import Tab from '../common/Tabs/Tab';
import TabHeader from '../common/Tabs/TabsHeader';
import Spinner from '../common/Spinner';
import Profile from './Profile';
import Subscriptions from './Subscriptions';
import { loadAccountPageRequest } from './actions';
import styles from './AccountPage.scss';

export const AccountPage = () => (
  <div
    className={classNames(
            'ui-canvas ui-canvas--full',
            styles.canvas,
        )}
    >
    <section className={styles.root}>
      <Tabs headerComponent={TabHeader}>
        <TabList>
          <Tab
            label="Profile"
            heading="My Account"
            url="/subscriptions/my-account/#tab=account"
                    />
          <Tab
            label="Subscriptions"
            heading="Subscription Packages"
            url="/subscriptions/my-account/#tab=subscriptions"
            canActivate={props => (props.userServices.data && props.userServices.data.subscriptions && props.userServices.data.subscriptions.length > 0)}
            redirectTo="/subscriptions"
          />
        </TabList>
        <TabContent>
          <TabPanel component={Profile} />
          <TabPanel component={Subscriptions} />
        </TabContent>
      </Tabs>
    </section>
  </div>
);

export default compose(
  setDisplayName('AccountPage'),
  connect(
    ({ accountPage, userInfo, userServices }) => ({ accountPage, userInfo, userServices }),
    { loadAccountPageRequest },
  ),
  withBreakpoint,
  lifecycle({
    componentDidMount() {
      this.props.loadAccountPageRequest();
    },
  }),
  branch(
    props => props.accountPage.fetching,
    renderComponent(Spinner),
  ),
  branch(
    props => props.accountPage.error,
    renderNothing,
  ),
  setPropTypes({
    accountPage: PropTypes.shape({
      error: PropTypes.bool,
      fetching: PropTypes.bool,
    }).isRequired,
    userInfo: PropTypes.shape({
      data: PropTypes.any,
      error: PropTypes.any,
      fetching: PropTypes.bool,
    }).isRequired,
    userServices: PropTypes.shape({
      data: PropTypes.any,
      error: PropTypes.any,
      fetching: PropTypes.bool,
    }).isRequired,
  }),
)(AccountPage);
